import { IState } from '../../../store';

export function getFlatViewOrderDescription(state: IState): string {
  return (
    state.offerData?.newbuildingFlatViewOrder?.orderStatus?.description ||
    'Вы записались на просмотр квартиры в данном ЖК'
  );
}
